<template>
  <!-- 数据展示区域 -->
    <div class="showDataView">
      <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          label="时间">
        </el-table-column>
        <el-table-column
          label="消息内容">
          <template slot-scope="scope"><div class="link" @click="showMes(scope.row)">查看</div></template>
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="DeviceName">
        </el-table-column>
        <el-table-column
          prop="traceId"
          label="traceId">
        </el-table-column>
        <el-table-column
        prop="businessType"
         label="业务类型">
         <!-- <template slot="header">
               <el-dropdown  size="small">
                <span class="el-dropdown-link">
                   业务类型(设备行为)<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>黄金糕</el-dropdown-item>
                  <el-dropdown-item>狮子头</el-dropdown-item>
                  <el-dropdown-item>螺蛳粉</el-dropdown-item>
                  <el-dropdown-item>双皮奶</el-dropdown-item>
                  <el-dropdown-item>蚵仔煎</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="operationType">
          <template slot="header">
            操作<el-tooltip content="操作含义请参考 文档" placement="top" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="statusCode">
          <template slot="header">
            状态<el-tooltip content="错误码含义请参考 文档" placement="top" effect="light">
              <span class="el-icon-question"></span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row class="footer" :span="24">
          <el-col :span="24">
            <el-row :span="24" class="dataListOperation" justify="end" type="flex">
              <el-col :span="12" >
                <el-row :span="24" type="flex" justify="end">
                  <div class="showAll"> 共<span>{{pageParams.total}}</span>条数据</div>
                  <el-pagination
                    layout="prev, pager, next"
                    @current-change="currentChange"
                    :page-size="pageParams.pageSize"
                    :total="pageParams.total">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

      <!-- 显示日志信息 -->
      <logMesView
        :productKey="productKey"
        :deviceName="deviceName"
        :mesView="mesView"
        :uniMsgId="uniMsgId"
        v-on:close-view="mesView.show = false"
        v-on:open-view="mesView.show = true">
      </logMesView>

    </div>
</template>
<script>
import logMesView from '@/components/systemOperation/logMesView'
import { eventBus } from '@/utils/eventBus'
import { logProductList } from '@/api/log'
// import { dataFormat } from '@/utils'
export default {
  components: {
    logMesView
  },
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    },
    traceId: {
      type: String
    }
  },
  data () {
    return {
      pageParams: {
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      tableData: [
      ],
      mesView: {
        show: false
      },
      uniMsgId: ''
    }
  },
  methods: {
    showMes (row) {
      console.log('row:', row)
      this.uniMsgId = row.uniMsgId
      this.mesView.show = true
    },
    getLogProductList (searchParams) {
      if (!this.productKey) {
        return
      }
      let params
      if (searchParams) {
        this.pageParams.pageNumber = 1
        params = Object.assign({ productKey: this.productKey }, searchParams)
      } else {
        let Obj = {}
        if (this.deviceName) {
          Obj = {
            deviceName: this.deviceName,
            traceId: this.traceId
          }
        }
        params = Object.assign({ productKey: this.productKey }, Obj, this.pageParams)
      }
      console.log('查询日志发送的params：', params)
      logProductList(params).then(res => {
        res = res.data
        console.log('获取消息日志：', res)
        this.pageParams.total = res.data.total
        this.tableData = res.data.LogBusinessData
        // this.tableData.map(item => {
        //   item.createTime = dataFormat(item.createTime)
        // })
      })
    },
    currentChange (val) {
      this.pageParams.pageNumber = val
      this.getLogProductList()
    }
  },
  created () {
    this.getLogProductList()
    const that = this
    eventBus.$on('search-mes-log', (params) => {
      console.log('search-mes-log:', params)
      that.getLogProductList(params)
    })
  },
  watch: {
    productKey () {
      console.log('变化了')
      this.getLogProductList()
    }
  }
}
</script>
<style lang="less" scope>
 .showDataView{
    background-color: white;
    .has-gutter{
       font-size: 16px;
        font-weight: bold;
        color: #33373c;
    }
    .link{
      color: #0070cc;
      cursor: pointer;
      margin-left: 10px;
    }
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .footer{
      padding: 20px 10px ;
    }
    .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
  }
</style>
